import { Component, OnInit } from '@angular/core';
import { Ingredient } from '../../models/ingredient.model';
import { ConnectionService } from '../../services/connection.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class IngredientComponent implements OnInit {
  ingredients: Ingredient[]

  ingredient: any = {}

  updateItem: any = {}

  constructor(private connection: ConnectionService) { }

  ngOnInit() {
    this.connection.getIngredients()
    .subscribe(data => this.ingredients = data)
  }

  delete(ingredient) {
    this.connection.deleteIngredient(ingredient)
  }

  update(ingredient) {
    this.updateItem = ingredient;
  }

  addUpdatedItem() {
    this.connection.updateIngredient(this.updateItem);
  }

}
